<template>
  <div class="one">
    <div class="two">
      <div class="title">
        关于设立星系马戏团奖项的公告
      </div>

      <div class="center">
        <p>
          为星系马戏团项目更好更长远的发展运营，进一步提升星系马戏团项目的知名度与参与度，更好的提高公众对天文领域的认识与了解，鼓励更多天文爱好者的加入，中国虚拟天文台决定设立星系马戏团项目“2024年度优秀探索者”称号并对符合标准的项目参与者颁发电子证书。评选标准为截至2025年1月1日，根据标注过的所有数据，统计并计算每位参与者已知天体的准确率置信度和年度标注总数量，其中占比80%，占比20%，排名前10的参与者作为本年度的优秀探索者。
        </p>

        <p>
          根据上述标准，经Galaxy Circus项目团队和中国虚拟天文台一致确认，获得星系马戏团项目“2024年度优秀探索者”称号的名单为：
        </p>

        <div class="name">
          <span>刘晔翔</span>
          <span>郭加美</span>
          <span>毛李森</span>
          <span>曹梦柔</span>
          <span>区耀樟</span>
          <span>王 超</span>
          <span>刘博宇</span>
          <span>柳 晴</span>
          <span>张晗之</span>
          <span>杨 玥</span>
        </div>

        <p>所有荣誉证书将在一个月内以电子版形式发送至预留邮箱。请及时查看邮箱，以便接收并保存证书。无法联系到的获奖者请及时自行联系我们（citizenscience(at)china-vo.org）。</p>

        <p>中国虚拟天文台</p>
        <p>二〇二五年一月二十日</p>

      </div>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.one {
  width: 100%;
  height: 1000px;
  padding: 20px;

  .two {
    width: 100%;
    height: 100%;
    color: white;
    font-size: 18px;


    .title {
      width: 100%;
      text-align: center;
    }

    .center {
      width: 100%;

      p {
        text-indent: 2em;
        text-align: justify;
        line-height: 45px;
      }


      .name {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        /* 设置4列等宽 */
        gap: 10px;
        /* 单元格之间的间距 */
        max-width: 600px;
        /* 限制容器宽度 */
        margin: 0 auto;
        /* 居中显示 */
        text-align: center;

        /* 文字居中 */
        span {
          padding: 10px;
          font-size: 16px;
          /* 字体大小 */
        }
      }
    }

    .center p:nth-child(5) {
      text-align: right;
    }

    .center p:nth-child(6) {
      text-align: right;
    }
  }
}
</style>